// RESILIENT — "Completa tu look": recomendaciones surtidas con selector de talla.
// Web component: se refresca en cada cart:update y muestra 1 producto por "familia".
class RslntUpsell extends HTMLElement {
  connectedCallback() {
    this.row = this.querySelector('[data-upsell-row]');
    this.readAttrs();
    if (!this._clickBound) {
      this._clickBound = true;
      // Delegación: sobrevive los re-render del carrito.
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.rslnt-up__size');
        if (btn && !btn.hasAttribute('disabled') && !btn.disabled) this.add(btn);
      });
    }
    this.render();
    if (!this._bound) {
      this._bound = true;
      this._onCart = () => { this.readAttrs(); this.render(); };
      document.addEventListener('cart:update', this._onCart);
    }
    // Si el tema "morphea" y vacía la lista inyectada, la rellenamos de nuevo.
    if (!this._obs) {
      this._obs = new MutationObserver(() => {
        if (this._rendering || !this._hadProducts) return;
        const row = this.querySelector('[data-upsell-row]');
        if (row && row.childElementCount === 0) this.render();
      });
      this._obs.observe(this, { childList: true, subtree: true });
    }
  }

  disconnectedCallback() {
    if (this._onCart) document.removeEventListener('cart:update', this._onCart);
    if (this._obs) { this._obs.disconnect(); this._obs = null; }
    this._bound = false;
  }

  readAttrs() {
    this.pid = this.getAttribute('data-product-id');
    this.inCart = (this.getAttribute('data-in-cart') || '').split(',').filter(Boolean);
    this.exFam = (this.getAttribute('data-exclude-fam') || '').toLowerCase().split('|').map((s) => s.trim()).filter(Boolean);
  }

  hide() { this.style.display = 'none'; }

  familyKey(p) {
    const t = String(p.product_type || '').toLowerCase().trim();
    if (t) return t;
    return String(p.title || '').toLowerCase().split(/\s+/).slice(0, 2).join(' ');
  }

  imgUrl(p) {
    let img = p.featured_image || (p.images && p.images[0]) || '';
    if (img && typeof img === 'object') img = img.src || '';
    return img ? (img.indexOf('//') === 0 ? 'https:' + img : img) : '';
  }

  sizeOrder(l) {
    const o = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    const i = o.indexOf(String(l).toUpperCase());
    return i < 0 ? 99 : i;
  }

  sizesFor(p) {
    const opts = p.options || [];
    const isObj = opts.length && typeof opts[0] === 'object';
    const names = isObj ? opts.map((o) => o.name) : opts;
    let idx = names.findIndex((n) => /talla|size|tama/i.test(n));
    if (idx < 0 && names.length === 1) idx = 0;
    if (idx < 0) return [];
    const pos = isObj ? (opts[idx].position || idx + 1) : idx + 1;
    const key = 'option' + pos;
    const map = new Map();
    (p.variants || []).forEach((v) => {
      const lbl = v[key];
      if (lbl == null) return;
      if (!map.has(lbl)) map.set(lbl, { label: lbl, vid: v.id, available: false });
      const e = map.get(lbl);
      if (v.available !== false && !e.available) { e.vid = v.id; e.available = true; }
    });
    return [...map.values()].sort((a, b) => this.sizeOrder(a.label) - this.sizeOrder(b.label));
  }

  card(p) {
    const url = this.imgUrl(p);
    const img = url
      ? `<img class="rslnt-up__img" src="${url}" alt="${(p.title || '').replace(/"/g, '&quot;')}" loading="lazy">`
      : '';
    const sizes = this.sizesFor(p);
    const v0 = (p.variants && p.variants.find((v) => v.available !== false)) || (p.variants && p.variants[0]) || {};
    const foot = sizes.length > 1
      ? `<div class="rslnt-up__sizes">${sizes.map((s) => `<button type="button" class="rslnt-up__size" data-vid="${s.vid}" ${s.available ? '' : 'disabled'}>${s.label}</button>`).join('')}</div>`
      : `<button type="button" class="rslnt-up__size rslnt-up__size--full" data-vid="${v0.id || ''}">Añadir</button>`;
    return `<div class="rslnt-up__card">
      <div class="rslnt-up__imgwrap">${img}</div>
      <div class="rslnt-up__foot">
        <div class="rslnt-up__addlabel">Añadir · elige talla</div>
        ${foot}
      </div>
    </div>`;
  }

  shuffle(a) {
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  }

  async fetchJson(url) {
    try {
      const res = await fetch(url);
      if (!res.ok) return [];
      const data = await res.json();
      return data.products || [];
    } catch (e) {
      return [];
    }
  }

  async render() {
    this.row = this.querySelector('[data-upsell-row]');
    if (!this.row) return this.hide();
    this.style.display = '';
    let raw = await this.fetchJson('/products.json?limit=100');
    if (!raw.length && this.pid) {
      raw = await this.fetchJson(`/recommendations/products.json?product_id=${this.pid}&limit=12&intent=related`);
    }

    const base = raw.filter(
      (p) => !this.inCart.includes(String(p.id)) && p.variants && p.variants.some((v) => v.available !== false)
    );
    // No misma categoría que lo comprado (con fallback si vaciaría la lista).
    let pool = base.filter((p) => !this.exFam.includes(this.familyKey(p)));
    if (pool.length < 3) pool = base;

    // Surtido: 1 producto por familia.
    const seen = new Set();
    const uniq = [];
    for (const p of this.shuffle(pool)) {
      const k = this.familyKey(p);
      if (seen.has(k)) continue;
      seen.add(k);
      uniq.push(p);
    }
    const products = (uniq.length ? uniq : pool).slice(0, 6);

    if (!products.length) { this._hadProducts = false; return this.hide(); }
    this._hadProducts = true;
    this._rendering = true;
    this.row.innerHTML = products.map((p) => this.card(p)).join('');
    requestAnimationFrame(() => { this._rendering = false; });
    // El click se maneja por delegación en connectedCallback.
  }

  async add(btn) {
    const vid = parseInt(btn.getAttribute('data-vid'), 10);
    const label = btn.textContent;
    if (!vid || vid < 1) {
      console.error('[RSLNT upsell] variante inválida:', btn.getAttribute('data-vid'));
      btn.textContent = '✗';
      setTimeout(() => { btn.textContent = label; }, 1200);
      return;
    }
    btn.disabled = true;
    btn.textContent = '…';
    try {
      const r = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 }),
      });
      if (!r.ok) {
        const err = await r.json().catch(() => ({}));
        console.error('[RSLNT upsell] /cart/add.js falló', r.status, err);
        btn.disabled = false;
        btn.textContent = '✗';
        setTimeout(() => { btn.textContent = label; }, 1500);
        return;
      }
      btn.textContent = '✓';
      // Vía confiable: recargar y reabrir el carrito (agrega de verdad y se ve).
      sessionStorage.setItem('rslntReopenCart', '1');
      setTimeout(() => window.location.reload(), 400);
    } catch (e) {
      console.error('[RSLNT upsell] excepción al agregar', e);
      btn.disabled = false;
      btn.textContent = label;
    }
  }
}

if (!customElements.get('rslnt-upsell')) {
  customElements.define('rslnt-upsell', RslntUpsell);
}

// Tras recargar por un "Añadir" del upsell, reabrir el carrito automáticamente.
(function reopenCartAfterAdd() {
  if (sessionStorage.getItem('rslntReopenCart') !== '1') return;
  sessionStorage.removeItem('rslntReopenCart');
  const openIt = () => {
    const trigger =
      document.querySelector('[data-testid="cart-drawer-trigger"]') ||
      document.querySelector('.header-actions__cart-icon') ||
      document.querySelector('cart-drawer-component .header-actions__action');
    if (trigger) trigger.click();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(openIt, 350));
  } else {
    setTimeout(openIt, 350);
  }
})();
